import React from 'react'
import styled from 'styled-components/macro'
import palette from '../designSystem/variables/palette'
import { Spinner } from './Spinner'

type Props = {
  show: boolean
  /** When omitted, uses the default receptor/evidence copy. */
  message?: string
}

export const ReceptorSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 24px;

  p {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 150%;

    text-align: center;
    color: ${palette.neutral['900']};
  }
`

export function ReceptorScanSpinner(props: Props): JSX.Element {
  if (!props.show) {
    return <></>
  }
  const message = props.message ?? 'Checking receptors for evidence'
  return (
    <ReceptorSpinnerContainer>
      <Spinner title="" color="primary" size="m" marginRight={'24px'}></Spinner>
      <p>{message}</p>
    </ReceptorSpinnerContainer>
  )
}
